import { render, staticRenderFns } from "./FlatSelectorText.component.vue?vue&type=template&id=319a87d4&scoped=true&lang=pug"
import script from "./FlatSelectorText.component.vue?vue&type=script&lang=ts"
export * from "./FlatSelectorText.component.vue?vue&type=script&lang=ts"
import style0 from "./FlatSelectorText.component.vue?vue&type=style&index=0&id=319a87d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a87d4",
  null
  
)

export default component.exports